import { useState, useCallback } from 'react';

const useApiAction = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const performAction = useCallback(async ({ url, method = 'POST', body }) => {
    setIsLoading(true);
    setError(null);
    setData(null);
    try {
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document
            .querySelector('meta[name="csrf-token"]')
            ?.getAttribute('content'),
        },
        body: JSON.stringify(body),
      });
      const responseData = await response.json();
      if (!response.ok) {
        setError(
          new Error(
            responseData.error || `HTTP Error! Status: ${response.status}`
          )
        );
        return null;
      }
      setData(responseData);
      return responseData;
    } catch (err) {
      setError(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { performAction, isLoading, error, data };
};

export default useApiAction;
